import clsx from 'clsx';
import React from 'react';

type Tab = {
  id: string;
  label: string;
};

type PoolListTabsProps = {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
};

export const PoolListTabs: React.FC<PoolListTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex flex-wrap items-center gap-6">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <div
            key={tab.id}
            className={clsx('cursor-pointer pb-1 text-base transition-colors hover:text-[#113D7B]', {
              'text-[#113D7B] border-b-2 border-[#113D7B] font-bold': isActive,
              'text-[#B2B2B2] font-medium': !isActive,
            })}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </div>
        );
      })}
    </div>
  );
};
